<template>
    <form class="c-cars-sidebar__wrap">
        <div class="c-cars-sidebar">
            <div class="c-cars-sidebar__inner">
                <!-- <h3 class="c-cars-sidebar__title">Recherche par numéro de stock</h3> -->
                <div class="c-cars-sidebar__group">
                    <div class="c-car-sidebar__search__wrap">
                        <input type="text" class="o-input c-car-sidebar__search__input" v-model="$root.q" placeholder="Mot-clé ou stock">
                        <svgIco icon="search" />
                    </div>
                </div>
                <h3 class="c-cars-sidebar__title">Inventaire</h3>
                <div class="c-cars-sidebar__group">
                    <label v-for="item in filters.inventory" :key="item.value" class="c-cars-sidebar__label">
                        <input type="checkbox" v-model="item.selected">
                        <span>{{item.label}}</span>
                    </label>
                    
                </div>
                <h3 class="c-cars-sidebar__title">Marques</h3>
                <div class="c-cars-sidebar__group">
                    <template v-for="item in filters.makes">
                        <label v-if="!isNewQuery() || item.available_for_new" :key="item.value" class="c-cars-sidebar__label">
                            <input type="checkbox" v-model="item.selected">
                            <span>{{item.label}}</span>
                        </label>
                    </template>
                </div>
                <template v-if="hasSelectedMakes">
                    <h3 class="c-cars-sidebar__title">Modèles</h3>
                    <template v-for="make in selectedMakes" :key="make.value">
                        <h4 class="c-cars-sidebar__subtitle">{{make.label}}</h4>
                        <div class="c-cars-sidebar__group">
                            <label v-for="model in make.models" :key="model.value" class="c-cars-sidebar__label">
                                <input type="checkbox" v-model="model.selected">
                                <span>{{model.label}}</span>
                            </label>
                        </div>
                    </template>
                </template>
                <h3 class="c-cars-sidebar__title">Type de véhicule</h3>
                <div class="c-cars-sidebar__group">
                    <label v-for="item in filters.types" :key="item.value" class="c-cars-sidebar__label">
                        <input type="checkbox" v-model="item.selected">
                        <span v-html="item.label"></span>
                    </label>
                </div>
                <h3 class="c-cars-sidebar__title">Année</h3>
                <div class="c-cars-sidebar__group">
                    <MultiRangeSlider style="width:92.5%;position:relative;" baseClassName="multi-range-slider-bar-only"
                        :min="filters.yearMinRange"
                        :max="filters.yearMaxRange"
                        :minValue="filters.yearMin"
                        :maxValue="filters.yearMax"
                        :step="1"
                        @input="filters.yearMin = $event.minValue; filters.yearMax = $event.maxValue">
                    </MultiRangeSlider>
                    <span>De {{ filters.yearMin }} à {{ filters.yearMax }}</span>
                    
                </div>
                <h3 class="c-cars-sidebar__title">Prix</h3>
                <div class="c-cars-sidebar__group">
                    <MultiRangeSlider style="width:92.5%;position:relative;" baseClassName="multi-range-slider-bar-only"
                        :min="filters.priceMinRange"
                        :max="filters.priceMaxRange"
                        :minValue="filters.priceMin"
                        :maxValue="filters.priceMax"
                        :step="2500"
                        @input="filters.priceMin = $event.minValue; filters.priceMax = $event.maxValue">
                    </MultiRangeSlider>
                    <span>De {{ cash(filters.priceMin) }} à {{ cash(filters.priceMax) }}</span>
                </div>
                <h3 class="c-cars-sidebar__title">Paiement hebdo</h3>
                <div class="c-cars-sidebar__group">
                    <MultiRangeSlider style="width:92.5%;position:relative;" baseClassName="multi-range-slider-bar-only"
                        :min="filters.weeklyMinRange"
                        :max="filters.weeklyMaxRange"
                        :minValue="filters.weeklyMin"
                        :maxValue="filters.weeklyMax"
                        :step="10"
                        @input="filters.weeklyMin = $event.minValue; filters.weeklyMax = $event.maxValue">
                    </MultiRangeSlider>
                    <span>De {{ cash(filters.weeklyMin) }} à {{ cash(filters.weeklyMax) }}</span>
                </div>
                <h3 class="c-cars-sidebar__title">Kilométrage</h3>
                <div class="c-cars-sidebar__group">
                    <MultiRangeSlider style="width:92.5%;position:relative;" baseClassName="multi-range-slider-bar-only"
                        :min="filters.kmsMinRange"
                        :max="filters.kmsMaxRange"
                        :minValue="filters.kmsMin"
                        :maxValue="filters.kmsMax"
                        :step="5000"
                        @input="filters.kmsMin = $event.minValue; filters.kmsMax = $event.maxValue">
                    </MultiRangeSlider>
                    <span>De {{ nb(filters.kmsMin) }} km à {{ nb(filters.kmsMax) }} km</span>
                </div>
                <!--<h3 class="c-cars-sidebar__title">Checkboxes</h3>
                <div class="c-cars-sidebar__group">
                    <label for="checkbox-1" class="c-cars-sidebar__label">
                        <input type="checkbox" name="checkbox-1" id="checkbox-1">
                        <span>Checkbox</span>
                    </label>
                    <label for="checkbox-2" class="c-cars-sidebar__label">
                        <input type="checkbox" name="checkbox-2" id="checkbox-2">
                        <span>Checkbox</span>
                    </label>
                </div>
                <h3 class="c-cars-sidebar__title">Radios</h3>
                <div class="c-cars-sidebar__group">
                    <label for="radio-1" class="c-cars-sidebar__label -radio">
                        <input type="radio" name="radios" id="radio-1">
                        <span>Radio</span>
                    </label>
                    <label for="radio-2" class="c-cars-sidebar__label -radio">
                        <input type="radio" name="radios" id="radio-2">
                        <span>Radio</span>
                    </label>
                </div>
               
                
                <h3 class="c-cars-sidebar__title">Transmission</h3>
                <div class="c-cars-sidebar__group">
                    <label for="#" class="c-cars-sidebar__label">
                        <input type="checkbox" name="" id="">
                        <span>Automatique</span>
                    </label>
                    <label for="#" class="c-cars-sidebar__label">
                        <input type="checkbox" name="" id="">
                        <span>Manuelle</span>
                    </label>
                </div>
                <h3 class="c-cars-sidebar__title">Traction</h3>
                <div class="c-cars-sidebar__group">
                    <label for="#" class="c-cars-sidebar__label">
                        <input type="checkbox" name="" id="">
                        <span>Traction intégrale</span>
                    </label>
                    <label for="#" class="c-cars-sidebar__label">
                        <input type="checkbox" name="" id="">
                        <span>Traction</span>
                    </label>
                    <label for="#" class="c-cars-sidebar__label">
                        <input type="checkbox" name="" id="">
                        <span>Propulsion</span>
                    </label>
                    <label for="#" class="c-cars-sidebar__label">
                        <input type="checkbox" name="" id="">
                        <span>4x4</span>
                    </label>
                </div>
                <h3 class="c-cars-sidebar__title">Carburant</h3>
                <div class="c-cars-sidebar__group">
                    <label for="#" class="c-cars-sidebar__label">
                        <input type="checkbox" name="" id="">
                        <span>Essence</span>
                    </label>
                    <label for="#" class="c-cars-sidebar__label">
                        <input type="checkbox" name="" id="">
                        <span>Diesel</span>
                    </label>
                    <label for="#" class="c-cars-sidebar__label">
                        <input type="checkbox" name="" id="">
                        <span>Hybride</span>
                    </label>
                    <label for="#" class="c-cars-sidebar__label">
                        <input type="checkbox" name="" id="">
                        <span>Électrique</span>
                    </label>
                </div>
                <h3 class="c-cars-sidebar__title">Nombre de passagers</h3>
                <div class="c-cars-sidebar__group">
                    <label for="#" class="c-cars-sidebar__label">
                        <input type="checkbox" name="" id="">
                        <span>2</span>
                    </label>
                    <label for="#" class="c-cars-sidebar__label">
                        <input type="checkbox" name="" id="">
                        <span>5</span>
                    </label>
                    <label for="#" class="c-cars-sidebar__label">
                        <input type="checkbox" name="" id="">
                        <span>6</span>
                    </label>
                    <label for="#" class="c-cars-sidebar__label">
                        <input type="checkbox" name="" id="">
                        <span>7</span>
                    </label>
                    <label for="#" class="c-cars-sidebar__label">
                        <input type="checkbox" name="" id="">
                        <span>8</span>
                    </label>
                </div-->
            </div>
            <div class="c-cars-sidebar-footer">
                <button class="o-button-cars-filter__clear" onclick="location.href='/inventaire/'">
                    Réinitialiser
                </button>
                <button class="o-button-cars-filter__submit" @click.prevent="$root.sidebarActive=false">
                    <span>({{$root.total}})</span> Appliquer
                    <svgIco icon="cars-arrow-right" />
                </button>
            </div>
        </div>
    </form>
</template>

<script>


export default {
    name: 'Cards',
    props: {
        filters: {
            type: Object,
            required: true
        }
    },
    
    data() {
        return {
           
        }
    },
    computed: {
        hasSelectedMakes() {
            return this.filters.makes.some(make => make.selected);
        },
        selectedMakes() {
            return this.filters.makes.filter(make => make.selected);
        }
    },
    methods: {
        
    }
}
</script>